import { useStore } from '../store/store'
import { fmtPct } from '../lib/format'
import { Banner, Button, Card, NumberField, PageHead, SelectField, Toggle } from '../components/ui'

const CURRENCIES = ['USD', 'EUR', 'GBP', 'CAD', 'AUD']

export function Settings() {
  const store = useStore()
  const { risk, scanSettings, meta } = store

  const resetSeed = () => {
    if (window.confirm('Replace all current data with fresh sample data? This cannot be undone.')) store.resetToSeed()
  }
  const clearAll = () => {
    if (window.confirm('Erase everything and start from sample data? This cannot be undone.')) {
      try {
        localStorage.removeItem('edgelab-store-v1')
      } catch {
        store.resetToSeed()
        return
      }
      store.resetToSeed()
    }
  }

  return (
    <div className="stack">
      <PageHead title="Settings">
        Local-first preferences. Everything is stored in this browser only — clearing site data wipes it.
      </PageHead>

      <div className="grid cols-2">
        <Card title="General">
          <SelectField label="Base currency" value={risk.baseCurrency} onChange={(v) => store.setRisk({ baseCurrency: v })} options={CURRENCIES.map((c) => ({ value: c, label: c }))} />
          <NumberField label="Bankroll" value={risk.bankroll} onChange={(v) => store.setRisk({ bankroll: v })} step={100} />
          <Toggle label="Paper-first mode" checked={meta.paperFirstMode} onChange={store.setPaperFirst} />
        </Card>

        <Card title="Scanner thresholds" subtitle="The bar an idea must clear to avoid an automatic skip">
          <NumberField label="Minimum edge" value={scanSettings.minEdge} onChange={(v) => store.setScanSettings({ minEdge: v })} step={0.005} min={0} max={0.2} hint={fmtPct(scanSettings.minEdge, 1)} />
          <NumberField label="Minimum data quality" value={scanSettings.minDataQuality} onChange={(v) => store.setScanSettings({ minDataQuality: v })} step={0.05} min={0} max={1} hint={fmtPct(scanSettings.minDataQuality, 0)} />
          <NumberField label="Minimum confidence" value={scanSettings.minConfidence} onChange={(v) => store.setScanSettings({ minConfidence: v })} step={0.05} min={0} max={1} hint={fmtPct(scanSettings.minConfidence, 0)} />
          <NumberField label="Minimum liquidity" value={scanSettings.minLiquidity} onChange={(v) => store.setScanSettings({ minLiquidity: v })} step={0.05} min={0} max={1} hint={fmtPct(scanSettings.minLiquidity, 0)} />
        </Card>
      </div>

      <Card title="Data">
        <Banner tone="warn">These actions are destructive and operate on your local browser data only.</Banner>
        <div className="btn-row" style={{ marginTop: 12 }}>
          <Button onClick={resetSeed}>Reset to sample data</Button>
          <Button variant="danger" onClick={clearAll}>Erase all local data</Button>
        </div>
      </Card>

      <Card title="About">
        <div className="kv"><span className="k">App</span><span className="v">EdgeLab v{meta.version}</span></div>
        <div className="kv"><span className="k">Created</span><span className="v">{meta.createdAt.slice(0, 10)}</span></div>
        <div className="kv"><span className="k">Storage</span><span className="v">localStorage (this browser)</span></div>
        <p className="help" style={{ marginTop: 10 }}>
          EdgeLab is open research software for analyzing edges in stocks, prediction markets and legal betting odds. It is not financial or betting advice.
        </p>
      </Card>
    </div>
  )
}
